import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { individualRestrictionGuard } from '../../guards/individual-restriction.guard';

export const admin: Routes = [
  { path: 'paragraph', redirectTo: 'paragraph/list', pathMatch: 'full' },
  {
    path: 'paragraph',
    children: [
      {
        path: 'list',
        loadComponent: () => import('./list/paragraph.component').then((m) => m.ParagraphComponent),
        canActivate: [individualRestrictionGuard],
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class paragraphRoutingModule {
  static routes = admin;
}
